module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/crocodile-mobile.0dde5e61.png";